import ESGReportDownloadTemplate from '../components/ESGReportDownloadTemplate'

export default {
  name: 'ESGReportDownload',
  data () {
    return {
      
    }
  },
  components: {
    ESGReportDownloadTemplate
  }
}


// WEBPACK FOOTER //
// ./src/esg/js/ESGReportDownload.js